import type { NoteName } from 'shared/definitions/musicTheory/notesAndAccidentals';
import Note from '../note';

export type TemperamentName = 'equal' | 'just';

export abstract class Temperament {
  protected temperamentBase: Note;

  protected temperamentBaseFrequency: number;

  constructor(temperamentBase: Note | NoteName = 'C', temperamentBaseFrequency?: number) {
    this.temperamentBase = new Note(temperamentBase);
    this.temperamentBaseFrequency = temperamentBaseFrequency ?? this.temperamentBase.getFrequency();
  }

  setBase(temperamentBase: Note | NoteName, temperamentBaseFrequency?: number) {
    this.temperamentBase = new Note(temperamentBase);
    this.temperamentBaseFrequency = temperamentBaseFrequency ?? this.temperamentBase.getFrequency();
  }

  /**
   * Returns the frequency for a midi number in this temperament
   * @param midi
   */
  abstract getFrequency(midi: number): number;
}
